/**
 * 🛠️ DEFINITION EXTRACTOR (Verbose)
 */
export default function extractDimensions(rows, colMap) {
  console.log("🛠️ [EXTRACTOR:DEF] Processing started...");
  const dimensions = [];
  const stack = [];

  const L_IDX = colMap["Level"];
  const T_IDX = colMap["Technical Name"];

  if (L_IDX === undefined || T_IDX === undefined) {
      console.error("❌ [EXTRACTOR:DEF] Missing critical columns in Map!", colMap);
      return [];
  }

  for (let i = 1; i < rows.length; i++) {
    const r = rows[i];
    const level = parseInt(r[L_IDX]);
    const id = r[T_IDX];

    if (!id || isNaN(level)) continue;

    const node = { id };

    if (level === 1) {
      stack[0] = node;
    } else {
      const parentNode = stack[level - 2];
      if (parentNode) {
        dimensions.push({ axis: parentNode.id, member: id });
      }
      stack[level - 1] = node;
    }

    // Progress heart-beat every 5000 rows
    if (i % 5000 === 0) console.log(`⏳ [EXTRACTOR:DEF] Processed ${i} rows...`);
  }

  console.log(`✅ [EXTRACTOR:DEF] Finished. Found ${dimensions.length} Axis-Member pairs.`);
  return dimensions;
}